import {
  KeyboardBackspaceRounded,
  GroupRounded,
  DescriptionRounded,
  SportsKabaddiRounded,
  HotTubRounded,
} from '@material-ui/icons';
import { ReactElement } from 'react';

// Components.
import { Link } from 'components';

// Core.
import { LinkVariant } from 'core';

// Hooks.
import { useClickEvent } from 'hooks';

// Styles
import styles from './Featured.module.scss';

export const Featured = (): ReactElement => {
  const fireEvent = useClickEvent();

  return (
    <div className={styles.container}>
      <div className={styles.eyebrow}>Featured Activity Searches</div>
      <ul>
        <li>
          <Link
            className={styles.link}
            icon={KeyboardBackspaceRounded}
            onClick={() => fireEvent({ EventAction: 'Links', EventLabel: 'COVID-19 Cardiovascular' })}
            to="/activity/search?searchText=COVID"
            variant={LinkVariant.Tertiary}
          >
            COVID-19
          </Link>
          <div className={styles.content}>
            <div className={styles.icon}>
              <GroupRounded />
            </div>
            <p>Activities related to diagnosis, treatment and research of COVID-19</p>
          </div>
        </li>
        <li>
          <Link
            className={styles.link}
            icon={KeyboardBackspaceRounded}
            onClick={() => fireEvent({ EventAction: 'Links', EventLabel: 'Preoperative Medication' })}
            to="/activity/search?searchText=Pain%20Management"
            variant={LinkVariant.Tertiary}
          >
            Pain Management
          </Link>
          <div className={styles.content}>
            <div className={styles.icon}>
              <SportsKabaddiRounded />
            </div>
            <p>Activities related to pain management, safer controlled substance prescribing and opioid medications</p>
          </div>
        </li>
        <li>
          <Link
            className={styles.link}
            icon={KeyboardBackspaceRounded}
            onClick={() => fireEvent({ EventAction: 'Links', EventLabel: 'Clinical Care Transfusion' })}
            to="/activity/search?participationFee[]=No%2C%20it%27s%20free&locationTypes[]=Live-Streamed,Online&type[]=Conference,In-House%20Seminar,Online%20Learning&registration[]=Open%20to%20all"
            variant={LinkVariant.Tertiary}
          >
            Free and Online Accredited Continuing Education
          </Link>
          <div className={styles.content}>
            <div className={styles.icon}>
              <HotTubRounded />
            </div>
            <p>Free continuing education you can complete online</p>
          </div>
        </li>
        <li>
          <Link
            className={styles.link}
            icon={KeyboardBackspaceRounded}
            onClick={() => fireEvent({ EventAction: 'Links', EventLabel: 'Hospital Diagnostic Cases' })}
            to="/activity/search?isMoc=true"
            variant={LinkVariant.Tertiary}
          >
            Education that Counts for Board Certification
          </Link>
          <div className={styles.content}>
            <div className={styles.icon}>
              <DescriptionRounded />
            </div>
            <p>Activities that offer Maintenance of Certification or Continuous/Continuing Certification credit</p>
          </div>
        </li>
      </ul>
    </div>
  );
};
